<template>
  <RouteAlive :include="routeMatches"
              @destroyed="handleDestroyed"
              @removed="handleRemoved"></RouteAlive>
</template>

<script>
import RouteAlive from './RouteAlive'
import Fragment from '../../../mixins/fragment'
export default {
  name: 'RouteKeepAlive',
  mixins: [Fragment],
  components: {
    RouteAlive
  },
  props: {
    routeMatches: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    handleDestroyed (key) {
      this.handleRemoved([key])
    },
    handleRemoved (keys) {
      if (keys && keys.length) {
        keys.forEach(key => {
          let matchId = key.split(':')[0]
          this.deleteFragment(matchId)
        })
      }
    }
  }
}
</script>
